export const ASSETS = {
  logo: '/assets/logos/stolmal_logo1.jpg',
};
